import store from '../store_instance';
import { uuid } from '../../../shared/lib/uuid';
import presentationUI from 'lib/presentation-ui';

class WaypointsUI {

  constructor() {
    this.isVisible = false;
    this.selectedWaypoint = null;
  }

  setCanvas(canvas) {
    this.canvas = canvas;
  }

  setTab(tab) {
    this.tab = tab;
  }

  setSelector(selector) {
    this.selector = selector;
  }

  updateWaypoints() {
    const waypoints = this.getWaypoints();
    if (this.tab) {
      this.tab.updateWaypoints(waypoints);
    }
  }

  hideTabMenus() {
    const { tab } = this;

    if (!tab) return;

    tab.hideMenu();
    tab.hideTopMenu();
  }

  getPresentation() {
    return store.presentations[0];
  }

  getWaypoints() {
    const presentation = this.getPresentation();
    return presentation && presentation.getWaypoints() || [];
  }

  getWaypoint({ id }) {
    return this.getPresentation().getWaypoint({ id });
  }

  getNextOrderIndex() {
    const waypoints = this.getWaypoints();
    return waypoints.length ? waypoints.slice(-1).pop().orderIndex + 1 : 1;
  }

  rowIsInView(listItemWaypoint) {
    const scrollElement = listItemWaypoint.parentElement.parentElement;
    const containerTop = $(scrollElement).scrollTop();
    const containerBottom = containerTop + $(scrollElement).height();
    const rowTop = $(listItemWaypoint).offset().top - $(scrollElement).offset().top;
    const rowBottom = rowTop + $(listItemWaypoint).height();

    if (rowTop < 0) {
      // scroll up
      return true;
    }

    if (rowBottom + containerTop > containerBottom) {
      // scroll down
      return false;
    }

    // no scroll
    return null;
  }

  selectWaypoint({ waypointId, scrollTab = false, presenting = false }) {
    const listItemWaypoint = document.getElementById(`waypoint-list_item--${waypointId}`);

    if (listItemWaypoint) {
      listItemWaypoint.classList.add('waypoint-list_item--active', 'side-tab_item--active');

      if (scrollTab) {
        // Scroll drawer to current item
        const alignToTop = this.rowIsInView(listItemWaypoint);
        if (alignToTop !== null) {
          listItemWaypoint.scrollIntoView(alignToTop);
        }
      }
    }
    if (presenting) {
      listItemWaypoint.classList.add('waypoint-list_item--selected');
    }

    this.selectedWaypoint = waypointId;
  }

  deselectWaypoints({ scrollTab = false, stopPresenting = false } = {}) {
    const activeListItemWaypoint = document.querySelector('.waypoint-list_item--active');

    if (activeListItemWaypoint) {
      activeListItemWaypoint.classList.remove('waypoint-list_item--active', 'side-tab_item--active');

      if (scrollTab) {
        // Scroll drawer to the top
        // TODO: Hate to be relying on specific DOM tree, should be independent
        activeListItemWaypoint.parentNode.parentNode.scrollTop = 0;
      }
    }

    const selectedListItemWaypoint = document.querySelector('.waypoint-list_item--selected');
    if (stopPresenting && selectedListItemWaypoint) {
      activeListItemWaypoint.classList.remove('waypoint-list_item--selected', 'side-tab_item--selected');
    }

    this.selectedWaypoint = null;
  }

  startAdding() {
    this.isAdding = true;
    this.selector.show();
  }

  stopAdding() {
    this.isAdding = false;
    this.selector.hide();
  }

  startEditing({ id }) {
    this.stopPresentationIfActiveWaypointIsNot(id);
    this.isEditing = id;
    canvas.enablePanZoom();
    presentationUI.panTo(
      this.getWaypoint({ id }).nodeIds.map(nId => store.getNode(nId)),
      { doNotHighlight: true }
    );
    this.selector.show();
  }

  stopEditing() {
    this.isEditing = false;
    this.selector.hide();
    // if presenting current waypoint, refresh
    if (presentationUI.isPresenting) {
      presentationUI.refresh();
    }
  }

  createWaypointsPresentation() {
    const { operation } = this.canvas;

    // Add the Waypoints Presentation to the store
    store.addPresentation({
      id: uuid(),
      title: 'Waypoints',
      createdByUserId: window.user.id,
    });

    // Once added, this.getPresentation() should return it.
    // Which we can use to add it to the DB.
    operation.createPresentation({
      presentation: this.getPresentation(),
      onFailure: (...rest) => console.log('arguments', rest),
    });

    this.updateWaypoints();
  }

  autopopulatableNodes() {
    return store.topNodes().filter(n => {
      const l = n.link();
      if (l && l.getTopLevelParentNode()) return false;
      return true;
    });
  }

  autopopulatePresentation(presentation) {
    // get top level nodes and link nodes (exclude link nodes within systems)
    // sort nodes left to right, top to bottom
    const sortedNodes = this.autopopulatableNodes().sort((a,b) =>
      (a.absolutePosition.x - b.absolutePosition.x) + (a.absolutePosition.y - b.absolutePosition.y)
    );
    const operationMessages = [];
    for (const node of sortedNodes) {
      this.addWaypoint({
        nodeIds: [node.id],
        title: node.title,
        operationMessages
      });
    }
    const { operation } = this.canvas;

    if (operationMessages.length) {
      operation.batchOperation({
        messages: operationMessages,
        onFailure: (error) => console.log(`autopopulatePresentation batchOperation failed, ${error}`)
      });
    }
  }

  addWaypoint({ nodeIds, title, operationMessages }) {
    if (!this.getPresentation()) {
      this.createWaypointsPresentation();
    }
    const presentation = this.getPresentation();
    const { id: presentationUUID } = presentation;
    const { operation } = this.canvas;

    const waypoint = presentation.addWaypoint({
      id: uuid(),
      title,
      nodeIds,
      orderIndex: this.getNextOrderIndex(),
      createdByUserId: window.user.id,
    });

    if (operationMessages) {
      const message = operation.messages.addPresentationWaypoint({
        presentationUUID,
        waypoint
      });
      operationMessages.push(message);
    } else {
      operation.addPresentationWaypoint({
        presentationUUID,
        waypoint,
        onFailure: (...rest) => console.log('arguments', rest),
      });
      // only call this stuff if we're adding a single waypoint (manually)
      this.stopAdding();
      this.refreshRunningPresentation();
      this.updateWaypoints();

      this.tab.scrollToEnd();
      presentationUI.highlightNodes(
        waypoint.nodeIds,
        true
      );
    }

  }

  editWaypoint({ id, nodeIds }) {
    const presentation = this.getPresentation();
    const { id: presentationUUID } = presentation;
    const { operation } = this.canvas;

    let prevNodeIds = [];

    const waypoint = presentation.getWaypoint({ id });
    if (waypoint) {
      prevNodeIds = waypoint.nodeIds;
      waypoint.nodeIds = nodeIds;
    }

    operation.updatePresentationWaypointNodeIds({
      presentationUUID,
      waypointUUID: waypoint.id,
      nodeIds: waypoint.nodeIds,
      prevNodeIds,
      onFailure: (...rest) => console.log('arguments', rest),
    });

    this.stopAdding();
    this.updateWaypoints();
  }

  editWaypointTitle({ waypoint, title }) {
    const presentation = store.getPresentation();
    const prevTitle = waypoint.title;
    if (title == prevTitle) {
      return;
    }
    waypoint.title = title;
    this.canvas.operation.updatePresentationWaypointTitle({
      presentationUUID: presentation.id,
      waypointUUID: waypoint.id,
      title,
      prevTitle,
    });
    this.updateWaypoints();
  }

  updateWaypointOrderIndexes(idIndexMappings) {
    const presentation = this.getPresentation();
    const { id: presentationUUID } = presentation;
    const { operation } = this.canvas;

    const prevIdIndexMappings = presentation.getWaypoints().map(({ id, orderIndex }) => ({ id, orderIndex }));

    presentation.updateWaypointOrderIndexes(idIndexMappings);

    operation.updatePresentationWaypointOrderIndexes({
      presentationUUID,
      idIndexMappings,
      prevIdIndexMappings,
      onFailure: (...rest) => console.log('arguments', rest),
    });

    // if we're presenting, update the current presentation to sync with the new order
    this.refreshRunningPresentation();
    this.updateWaypoints();
  }

  // refresh slides after reordering or removing a slide
  refreshRunningPresentation() {
    if (presentationUI.isPresenting && presentationUI.currentWaypoint) {
      const waypoints = this.getWaypoints();
      const newIndex = waypoints.findIndex(w => w.id == presentationUI.currentWaypoint.id);
      presentationUI.index = newIndex;
      presentationUI.slides = waypoints;
    }
  }

  removeWaypoint({ id }) {

    this.stopPresentationIfActiveWaypointMatches(id);

    const presentation = this.getPresentation();
    const waypoint = presentation.getWaypoint({ id });
    const { id: presentationUUID } = presentation;
    const { operation } = this.canvas;

    presentation.removeWaypoint({ id });

    operation.removePresentationWaypoint({
      presentationUUID,
      waypoint,
      onFailure: (...rest) => console.log('arguments', rest),
    });

    this.refreshRunningPresentation();
    this.updateWaypoints();
  }

  // stop presentation if the given waypoint is active  i.e. if you delete the active waypoint
  stopPresentationIfActiveWaypointMatches(id) {
    if (presentationUI.isPresenting && presentationUI.currentWaypoint && presentationUI.currentWaypoint.id == id) {
      presentationUI.stop();
    }
  }
  // stop presentation if the given waypoint is not the active one i.e. if you go to edit a different waypoint
  stopPresentationIfActiveWaypointIsNot(id) {
    if (presentationUI.isPresenting && presentationUI.currentWaypoint && presentationUI.currentWaypoint.id != id) {
      presentationUI.stop();
    }
  }

  clearWaypoints() {
    if (presentationUI.isPresenting) {
      presentationUI.stop();
    }
    const presentation = this.getPresentation();
    const { waypoints: prevWaypoints } = presentation;
    const { operation } = this.canvas;

    presentation.clearWaypoints();

    operation.clearPresentationWaypoints({
      presentation,
      prevWaypoints,
      onFailure: (...rest) => console.log('arguments', rest),
    });

    this.updateWaypoints();
  }
}

// singleton instance
export default (new WaypointsUI());



// WEBPACK FOOTER //
// ./starling/src/lib/waypoints-ui.js